import * as yup from 'yup'

export const schemaUpdateCreditTransactionModal = yup.object().shape({
    credit_name: yup.string().required(),
    credit_effective_date: yup.date().required(),
    credit_expiry_date: yup
        .date()
        .nullable()
        .when('credit_effective_date', (credit_effective_date, schema) =>
            credit_effective_date ? schema.min(credit_effective_date) : schema
        ),
    credit_warningable: yup.boolean().required(),
    credit_warning_amount: yup
        .number()
        .nullable()
        .when('credit_warningable', {
            is: true,
            then: (schema) =>
                schema
                    .required('Credit warning amount is required')
                    .min(1, 'Must be a positive number'),
            otherwise: (schema) => schema.nullable(),
        }),
})
